<template>
  <div :class="$style.style">
    <div id="mobileVote">
      <div class="adDiv">
        <div class="ad">
          <img :src="img" alt="">
        </div>
        <p class="voteName" style="white-space: pre-wrap">{{voteName?voteName:'投票活动名称'}}</p>
        <p class="voteTime">投票时间：{{startTime!==""?startTime:(new Date()).valueOf() | dateFormat('yyyy-MM-dd hh:mm:ss') }} 至{{endTime!==""?endTime:(new Date()).valueOf() | dateFormat('yyyy-MM-dd hh:mm:ss') }}</p>
  
      </div>
      <div class="voteContent">
        <div class="rectangle"></div>
        <div class="title">
          投票内容
        </div>
        <div class="content">
          <p style="word-wrap: break-word; white-space: pre-wrap" ref='contents' :class='{ps:isStyle}'>{{content!==""?content:"投票活动规则和活动简介"}}</p>
        </div>
        <p @click="toggleShow()" class="allShow">{{allVisible? '显示全部↓':'收起↑'}}</p>
        <!-- <p v-show="!allVisible" @click="allVisible=!allVisible" class="partShow">收起↑</p> -->
        <div class="template1" v-show="showStatus1">
          <ul class="vList" ref="element">
            <li v-for="(list,index) in arr" :key="index" v-if='candidateList.length==0'>
              <div class="img">
                <img :src="list.itemImage" alt="">
                <div class="triangle">
                  <p>{{list.itemIndex}}</p>
                </div>
              </div>
              <p class="name">{{list.itemTitle}}</p>
              <p class="tip">{{list.itemDescription}}</p>
              <button class="btn-vote">投票</button>
            </li>
          </ul>
        </div>
        <div class="template1" v-show="showStatus1" v-if='candidateList.length>0' ref="temp1">
          <ul class="vList">
            <li v-for="(list,index) in candidateList" :key="index">
              <div class="img">
                <img :src="list.itemImage" alt="">
                <div class="triangle">
                  <p>{{list.itemIndex}}</p>
                </div>
              </div>
              <p class="name" style="font-size:14px; color:#333">{{list.itemTitle}}</p>
              <p class="tip" style="font-size:12px; color:#666">{{list.itemDescription}}</p>
              <button class="btn-vote">投票</button>
              
            </li>
          </ul>
        </div>

        <div class="template2" v-show="showStatus2" v-if='candidateList.length==0'>
          <ul class="vList">
            <li v-for="(list,index) in arr" :key="index">
              <div class="left" v-show="showStatus3">
                <img :src="list.itemImage" alt="">
                 <div class="triangle">
                  <p>{{list.itemIndex}}</p>
                </div>
              </div>
              <div style="padding-top:12px; font-size:16px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap; margin-bottom:10px" class="right" v-show="showStatus3">
                <div>
                  <p><span v-show='!showStatus3'>{{list.itemIndex}}</span>{{list.itemTitle}}</p>
                </div>
                <p class="tip" style="font-size:14px;line-height: 23px">{{list.itemDescription}}</p>
                <button class="btn-vote">投票</button>
               
              </div>
              <div class="right right1" v-show="!showStatus3">
                <div>
                  <p style="padding:12px 0 0 12px; font-size:16px"><span v-show='!showStatus3'>{{list.itemIndex}}</span>{{list.itemTitle}}</p>
                </div>
                <p class="tip" style="font-size:14px;padding:8px 0 0 12px;">{{list.itemDescription}}</p>
                <button class="btn-vote temp3Btn">投票</button>
               
              </div>
            </li>
          </ul>
        </div>
        <div class="template2" v-show="showStatus2" v-if='candidateList.length>0' ref="temp2">
          <ul class="vList">
            <li v-for="(list,index) in candidateList" :key="index">
              <div class="left" v-show="showStatus3">
                <img :src="list.itemImage" alt="">
                 <div class="triangle">
                  <p>{{list.itemIndex}}</p>
                </div>
              </div>
              <div class="right" v-show="showStatus3">
                <div>
                  <p style="padding-top:12px; font-size:16px; overflow: hidden;text-overflow:ellipsis;white-space: nowrap; margin-bottom:10px"><span v-show='!showStatus3'>{{list.itemIndex}}</span>{{list.itemTitle}}</p>
                </div>
                <p class="tip" style="font-size:14px;line-height: 23px">{{list.itemDescription}}</p>
                <button class="btn-vote">投票</button>

              </div>
              <div class="right right1" v-show="!showStatus3">
                <div>
                  <p style="padding:12px 0 0 12px; font-size:16px"><span v-show='!showStatus3'>{{list.itemIndex}}</span>{{list.itemTitle}}</p>
                </div>
                <p class="tip" style="font-size:14px; padding:8px 0 0 12px;">{{list.itemDescription}}</p>
                <button class="btn-vote temp3Btn">投票</button>

              </div>
            </li>
          </ul>
        </div>
  
      </div>

    </div>
  </div>
</template>
<script>
import Filter from '../utils/filter';
export default {
  props: {
    showStatus1: Boolean,
    showStatus2: Boolean,
    showStatus3: Boolean,
    startTime: String,
    endTime: String,
    voteName: String,
    content: String,
    candidateList: Array || this.arr,
    img: String,
    ind: Number
  },
  data() {
    return {
      vList: [, , , , ,],
      allVisible: true,
      partVisible: true,
      textClip: false,
      isStyle: true,
      childValue: null,
      arr: [
        {
          itemImage: '',
          itemTitle: '1号  候选项1',
          itemDescription: '候选项简介'
        },
        {
          itemImage: '',
          itemTitle: '2号  候选项2',
          itemDescription: '候选项简介'
        }
      ]

      //content1: ''
    };
  },
  methods: {
    toggleShow: function() {
      this.allVisible = !this.allVisible;
      //this.isStyle = false;
      this.allVisible ? (this.isStyle = true) : (this.isStyle = false);
      // this.allVisible ? (this.lineClampText = '显示全部↓') : (this.lineClampText = '收起↑');
    }
    // childHeight() {
    //   let height1 = window.getComputedStyle(this.$refs.temp1).height;
    //   this.$emit('childByValue', height1);
    // }
  },
  computed: {
    // content1: function() {
    //   return this.content;
    // }
  },
  mounted() {
    console.log(this.ind, 'innd');
    this.$refs.contents.innerText;
    this.isStyle = true;
    // console.log(this.$refs.contents.innerText, '22222')
    let height = window.getComputedStyle(this.$refs.element).height;
    if (height > 605 + 'px') {
    }
  },
  filters: {
    dateFormat: function(date, fmt) {
      return Filter.date(date || '', fmt);
    }
  }
};
</script>
<style lang="less" module>
:local(.style) {
  * {
    font-size: 14px;
  }
  #mobileVote {
    background-color: #fdf7f0;
    width: 100%;
    height: 100%;
  }
  .adDiv {
    width: 280px;
    height: 220px;
    border: 8px solid #fcd9b9;
    border-bottom: none;
    background-color: #fff;
    .voteName {
      margin: 7px;
      font-size: 16px;
      font-weight: bolder;
    }
    .voteTime {
      margin: 0 7px;
      font-size: 12px;
    }
    .tip {
      word-wrap: break-word; // margin: 0 7px;
      font-size: 12px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre-wrap;

      span {
        color: red;
      }
    }
    .ad {
      width: 250px;
      height: 112px;
      position: relative;
      margin: 7px auto;
      background-color: #ebf1f5;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .voteContent {
    // width: 250px;
    // margin: 7px;
    position: relative;
    .content {
      width: 100%;
      padding: 0 20px;
      position: relative;
    }
    .allShow,
    .partShow {
      color: #fcbd63;
      margin: 10px 0 10px 25px;
    }
    .rectangle {
      width: 100px;
      height: 10px;
      background-color: #fee6d0;
      position: absolute;
      left: 93px;
      top: 15px;
    }
    .title {
      text-align: center;
      font-size: 20px;
      font-weight: bolder;
      position: relative;
    }
    .template1 {
      .vList {
        width: 100%;
        //column-gap: 10px;
        margin: 0 auto;
        //column-count: 2;
        // display: flex;
        // flex-direction: row;
        // flex-wrap: wrap;
        li {
          width: 45%;
          // flex: auto;
          // height: auto;
          float: left;
          margin: 6px;
          // break-inside: avoid;

          margin-bottom: 5px;
          box-shadow: 0 0 10px #dedbdb;
          padding: 0 0 25px 0;
          background: #fff;
          border-radius: 4px;
          .img {
            width: 100%;
            height: 123px;
            background-color: #ebf1f5;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .triangle {
              font-size: 0;
              line-height: 0;
              border-width: 30px;
              border-color: red;
              border-left-width: 0;
              border-style: dashed;
              border-right-style: solid;
              border-top-color: transparent;
              border-bottom-color: transparent;
              position: absolute;
              left: -4px;
              top: -19px;
              transform: rotate(45deg);
              p {
                transform: rotate(-45deg);
                position: absolute;
                left: 8px;
                top: 2px;
                color: #fff;
              }
            }
          }
          .name {
            width: 100px;
            overflow: hidden;
            margin: 5px 7px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .tip {
            word-wrap: break-word; // font-size: 12px;
            // color: #999;
            // // margin-left: 7px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 7px;
            height: 2.8em;
            white-space: pre-wrap;
          }
          .btn-vote {
            width: 100px;
            height: 26px;
            border-radius: 13px;
            background-color: #fda413;
            color: #ffffff;
            text-align: center;
            position: relative;
            left: 50%;
            top: 8px;
            margin-left: -50px;
            border: none;
          }
        }
      }
    }
    .template2 {
      .vList {
        li {
          height: auto;
          background-color: #ffffff;
          margin: 12px;
          overflow: hidden;
          // padding: 0 0 20px 0;

          .left {
            width: 33%;
            float: left;
            height: auto;
            position: relative;
            padding: 12px 0 0 12px;
            img {
              width: 100%;
            }
            .img {
              width: 80px;
              height: 80px;
            }
            .triangle {
              font-size: 0;
              line-height: 0;
              border-width: 30px;
              border-color: red;
              border-left-width: 0;
              border-style: dashed;
              border-right-style: solid;
              border-top-color: transparent;
              border-bottom-color: transparent;
              position: absolute;
              left: -4px;
              top: -19px;
              transform: rotate(45deg);
              p {
                transform: rotate(-45deg);
                position: absolute;
                left: 8px;
                top: 2px;
                color: #fff;
              }
            }
          }
          .right {
            float: right;
            margin-left: 2%;
            width: 64%;
            .name {
              width: 100px;
              overflow: hidden;
            }
            .tip {
              word-wrap: break-word; // font-size: 12px;
              color: #999;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden; // text-overflow: ellipsis;
              height: 3.2em;
              white-space: pre-wrap;
            }
            .btn-vote {
              width: 100px;
              height: 26px;
              border-radius: 13px;
              background-color: #fda413;
              color: #ffffff;
              text-align: center;
              position: relative;
              left: 50%;
              border: none;
              margin: 12px 0 12px -90px;
            }
          }
          .right1 {
            width: 100%;
            .tip {
              height: auto;
              white-space: pre-wrap;
            }

            .temp3Btn {
              width: 100px;
              height: 26px;
              border-radius: 13px;
              background-color: #fda413;
              color: #ffffff;
              text-align: center;
              position: relative;
              left: 50%;
              top: -2px;
              margin-left: -50px;
              border: none;
            }
          }
        }
      }
    }
    .vList:after,
    .adDiv:after {
      content: '.';
      display: block;
      height: 0;
      visibility: hidden;
      clear: left;
    }
  }
  .ps {
    width: 100%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 2;

    word-wrap: break-word; // margin: 0 7px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    p {
      img {
        width: 200px;
        height: 100px;
        display: block;
      }
    }
  }
}
</style>
